query getInstructionSettings {
	instructionSettings {
		catalogueImage
		catalogueEnabled
		createdAt
		updatedAt
	}
}